import React, { useEffect, useState } from 'react';
import './page.css';

function Portfolio() {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    const section = document.getElementById(targetId);
    if (section) section.scrollIntoView({ behavior: 'smooth' });
    setTimeout(() => setMenuOpen(false), 500);
  };

  useEffect(() => {
    // Map: selector → direction ('right' or 'up')
    const plan = [
      ['.hero .hero-name',        'right'],
      ['.hero .hero-text em',     'up'],
      ['.hero .hero-subtitle',    'up'],
      ['.hero .hero-quote',       'up'],
      ['.hero .hero-tech-stack',  'up'],
      ['.hero .hero-buttons',     'up'],
    ];

    // Slower timing
    const startDelay = 0.25;  // seconds
    const stagger    = 0.22;  // seconds between elements
    const duration   = 1.10;  // seconds per element

    // Expose duration to CSS (optional)
    document.documentElement.style.setProperty('--itkam-duration', `${duration}s`);

    const targets = [];
    plan.forEach(([sel, dir], i) => {
      const el = document.querySelector(sel);
      if (!el) return;
      el.classList.add('will-animate');
      if (dir === 'right') el.classList.add('will-animate--right');
      el.style.setProperty('--d', `${(startDelay + i * stagger).toFixed(2)}s`);
      targets.push(el);
    });

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target); // animate once
          }
        });
      },
      {
        root: null,
        threshold: 0.15,            // reveal a touch earlier
        rootMargin: '0px 0px -10% 0px',
      }
    );

    targets.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="portfolio-container">
      {/* 1. HEADER / NAVIGATION */}
      <header className="header">
        <div className="container">
          <nav className="navbar">
            <a
              href="#hero"
              className="nav-logo"
              onClick={(e) => handleNavClick(e, 'hero')}
            >
              <img src="/img/logo.png" alt="Logo" style={{ height: '40px' }} />
            </a>

            <button
              className={`burger ${menuOpen ? 'open' : ''}`}
              aria-label="Toggle navigation"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <span></span><span></span><span></span>
            </button>

            <ul className={`nav-menu ${menuOpen ? 'nav-menu--open' : ''}`}>
              <li><a href="#services"  onClick={(e)=>handleNavClick(e,'services')}  className="nav-link">Services</a></li>
              <li><a href="#journey"   onClick={(e)=>handleNavClick(e,'journey')}   className="nav-link">Timeline</a></li>
              <li><a href="#portfolio" onClick={(e)=>handleNavClick(e,'portfolio')} className="nav-link">Portfolio</a></li>
              <li><a href="#skills"    onClick={(e)=>handleNavClick(e,'skills')}    className="nav-link">Skills</a></li>
              <li><a href="#about"     onClick={(e)=>handleNavClick(e,'about')}     className="nav-link">About</a></li>
              <li><a href="#contact"   onClick={(e)=>handleNavClick(e,'contact')}   className="nav-link">Contact</a></li>
            </ul>
          </nav>
        </div>
      </header>

      <main>
        {/* 2. HERO SECTION (brand-first Itkam.dev) */}
                <section
                id="hero"
                className="hero"
                style={{
                    background: 'linear-gradient(135deg, var(--secondary-color) 0%, var(--card-background) 100%)',
                    color: 'var(--text-color)',
                    padding: '4rem 0',
                    fontFamily: 'var(--font-family)'
                }}
                >
                <div className="container hero-content">
                    <div className="hero-image-placeholder">
                    <img
                        src="/img/img.jpg"
                        alt="Itkam.dev Logo"
                        className="hero-img"
                        style={{ borderRadius: '50%', border: '4px solid var(--border-color)' }}
                    />
                    </div>

                    <div className="hero-text">
                    <h1 className="hero-name" style={{ color: 'var(--heading-color)' }}>
                        Itkam.dev
                    </h1>
                    <p><em>Managed by Cornilious Nolasco</em></p>
                    <p className="hero-subtitle">Software Developer & Key Account Manager</p>
                    <p className="hero-quote">
                        “Bridging software development and account management to deliver business-driven digital solutions.”
                    </p>

                    {/* Tech Stack */}
                    <div className="hero-tech-stack">
                        <h4>Core Technologies:</h4>
                        <div className="tech-icons">
                        <i className="devicon-csharp-plain colored" title="C#"></i>
                        <i className="devicon-dot-net-plain-wordmark colored" title=".NET Core"></i>
                        <i className="devicon-javascript-plain colored" title="JavaScript"></i>
                        <i className="devicon-react-original colored" title="React"></i>
                        <i className="devicon-python-plain-wordmark colored" title="Python"></i>
                        <i className="devicon-azure-plain-wordmark colored" title="Azure"></i>
                        <i className="devicon-postgresql-plain-wordmark colored" title="SQL"></i>
                        <i className="devicon-typescript-plain colored" title="TypeScript"></i>
                        <i className="devicon-nodejs-plain-wordmark colored" title="Node.js"></i>
                        <i className="devicon-firebase-plain-wordmark colored" title="Firebase"></i>
                        <i className="devicon-tailwindcss-plain colored" title="Tailwind CSS"></i>
                        <i className="devicon-git-plain colored" title="Git"></i>
                        </div>
                    </div>

                    {/* Buttons (unchanged) */}
                    <div className="hero-buttons">
                        <a href="#portfolio" onClick={(e) => handleNavClick(e, 'portfolio')} className="btn btn-primary">View Portfolio</a>
                        <a href="#contact" onClick={(e) => handleNavClick(e, 'contact')} className="btn btn-secondary">Let’s build your app</a>
                    </div>
                    </div>
                </div>
                </section>

                {/* 3. SERVICES */}
                <section id="services" className="services">
                <div className="container">
                    <h2 className="section-title">Core Services</h2>
                    <div className="services-grid">
                    <div className="service-item">
                        <h3>Full-Stack Development</h3>
                        <p>
                        End-to-end web & desktop applications using C#, .NET Core, React & Tailwind CSS.  
                        Architect RESTful APIs, integrate SQL/NoSQL databases, set up CI/CD pipelines,  
                        and deploy to Azure or Firebase for scalable, maintainable solutions.
                        </p>
                    </div>
                    <div className="service-item">
                        <h3>Business Strategy & KAM</h3>
                        <p>
                        KPI-driven sales strategy & account management.  
                        Design customer journeys, optimize CRM processes,  
                        forecast revenue, negotiate contracts, and boost retention through data insights.
                        </p>
                    </div>
                    <div className="service-item">
                        <h3>Technical Leadership</h3>
                        <p>
                            Lead technology, sales, customer-service and retention teams.  
                            Conduct process audits, optimize support workflows,  
                            mentor staff, and deliver workshops on best practices & self-leadership.
                        </p>
                    </div>
                    </div>
                            <div className="certificates certificates--ribbon ideal-clients">
                            <h4>Ideal Clients</h4>
                            <ul className="ribbon-list">
                                <li>Health & Wellness</li>
                                <li>SaaS & Tech Ventures</li>
                                <li>E-commerce Retailers</li>
                                <li>Process-Driven Businesses</li>
                            </ul>
                            </div>
                        </div>
                        </section>
                        {/* END SSERVICES */}
                
                {/* NEW: CAREER & EDUCATION TIMELINE */}
                <section id="journey" className="journey">
                <div className="container">
                    <h2 className="section-title">Professional Journey</h2>
                    <div className="timeline">

                    {/* 2025 – Ongoing  ·  Education */}
                    <div className="timeline-item">
                        <div className="timeline-content">
                        <span className="timeline-date">2025 – 2026</span>
                        <h3 className="timeline-title">IT / System Development</h3>
                        <p className="timeline-company">Lexicon, Linköping</p>
                        <p className="timeline-description">
                            Focused on C#, .NET Core, frontend, SQL, Visual Studio, GitHub & Azure.
                        </p>
                        </div>
                    </div>

                    {/* 2024  ·  Internship */}
                    <div className="timeline-item">
                        <div className="timeline-content">
                        <span className="timeline-date">2024</span>
                        <h3 className="timeline-title">Software Developer (Intern)</h3>
                        <p className="timeline-company">Beaver Codes AB, Norrköping</p>
                        <p className="timeline-description">
                            Contributed to full-stack projects in a professional agile environment.
                        </p>
                        </div>
                    </div>

                    {/* 2022 – 2024  ·  Education */}
                    <div className="timeline-item">
                        <div className="timeline-content">
                        <span className="timeline-date">2022 – 2024</span>
                        <h3 className="timeline-title">Software Development</h3>
                        <p className="timeline-company">Mölk Yrkeshögskola, Linköping</p>
                        </div>
                    </div>

                    {/* 2021 – 2022  ·  Education */}
                    <div className="timeline-item">
                        <div className="timeline-content">
                        <span className="timeline-date">2021 – 2022</span>
                        <h3 className="timeline-title">Key Account Management</h3>
                        <p className="timeline-company">TUC Yrkeshögskola, Linköping</p>
                        </div>
                    </div>

                    {/* 2016 – 2020  ·  Key Account Manager */}
                    <div className="timeline-item">
                        <div className="timeline-content">
                        <span className="timeline-date">2016 – 2020</span>
                        <h3 className="timeline-title">Key Account Manager</h3>
                        <p className="timeline-company">Zankutrol S.A. de C.V., El Salvador</p>
                        <p className="timeline-description">
                            Managed B2B accounts, negotiated contracts, tracked KPIs and led strategic planning.
                        </p>
                        </div>
                    </div>

                    {/* 2014 – 2015  ·  Team Manager */}
                    <div className="timeline-item">
                        <div className="timeline-content">
                        <span className="timeline-date">2014 – 2015</span>
                        <h3 className="timeline-title">Team Manager, Operations</h3>
                        <p className="timeline-company">Concentrix, El Salvador</p>
                        <p className="timeline-description">
                            Led bilingual customer-service teams for DISH Network, ensuring SLA compliance.
                        </p>
                        </div>
                    </div>

                    {/* 2009 – 2014  ·  Tech Support & Team Manager */}
                    <div className="timeline-item">
                        <div className="timeline-content">
                        <span className="timeline-date">2009 – 2014</span>
                        <h3 className="timeline-title">Technical Support & Team Manager</h3>
                        <p className="timeline-company">Concentrix (prev. Stream Global Services)</p>
                        <p className="timeline-description">
                            Supervised tech-support teams for Dish Network, Nextel & Microsoft Store; handled daily operations.
                        </p>
                        </div>
                    </div>

                    {/* 2007 – 2012  ·  Dell */}
                    <div className="timeline-item">
                        <div className="timeline-content">
                        <span className="timeline-date">2007 – 2012</span>
                        <h3 className="timeline-title">Sr. Tech Support, SRS & Customer Service</h3>
                        <p className="timeline-company">Dell Inc., El Salvador</p>
                        <p className="timeline-description">
                            Tier-2 support, hardware/software diagnosis, escalation management & sales support.
                        </p>
                        </div>
                    </div>

                    </div>
                </div>
                </section>
                {/* 5. PORTFOLIO / WORK SHOWCASE */}
                <section id="portfolio" className="portfolio">
                    <div className="container">
                        <h2 className="section-title">Portfolio Showcase</h2>
                        {/* FLAGSHIP PROJECT */}
                        <div className="flagship-project">
                            <div className="flagship-details">
                                <span className="flagship-tag">FLAGSHIP PROJECT</span>
                                <h3 className="flagship-title">IdeaSpark <span className="project-year">(2025-ongoing)</span></h3>
                                <p className="flagship-overview">An AI-powered automation platform building custom “Agents” to eliminate busywork for entrepreneurs and SMBs.</p>
                                <div className="feature-columns">
                                    <div>
                                        <h4>Feature Highlights</h4>
                                        <ul>
                                            <li>3-step onboarding workflow</li>
                                            <li>Library of pre-built Agents</li>
                                            <li>Mobile-first, conversion-oriented UX</li>
                                        </ul>
                                    </div>
                                    <div>
                                        <h4>Role & Impact</h4>
                                        <ul>
                                            <li>Product architect & lead engineer (React)</li>
                                            <li>Implemented key UI/UX components</li>
                                            <li>Business Intelligence Automation</li>
                                        </ul>
                                    </div>
                                </div>
                                {/* 
                                <div className="project-links">
                                <a href="#!" className="btn btn-primary">Live Demo</a>
                                <a href="#!" className="btn btn-secondary">Case Study</a>
                                </div>
                                */}
                            </div>
                            <div className="flagship-visuals" style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '1rem' }}>
                            <div className="flagship-main-image" style={{ marginBottom: '1rem' }}>
                                <img
                                src="/img/dashboard-visual.png"
                                alt="Dashboard Mockup"
                                style={{ width: '100%', borderRadius: '8px' }}
                                />
                            </div>
                            <div className="flagship-agent-cards" style={{ display: 'flex', gap: '1rem' }}>
                                <div className="agent-card" style={{ flex: '1' }}>
                                <img
                                    src="/img/FinanceTracker.png"
                                    alt="Finance Agent"
                                    style={{ width: '100%', borderRadius: '8px' }}
                                />
                                </div>
                                <div className="agent-card" style={{ flex: '1' }}>
                                <img
                                    src="/img/FeedbackAgent.png"
                                    alt="Feedback Agent"
                                    style={{ width: '100%', borderRadius: '8px' }}
                                />
                                </div>
                                <div className="agent-card" style={{ flex: '1' }}>
                                <img
                                    src="/img/PayRoll.png"
                                    alt="Payroll Agent"
                                    style={{ width: '100%', borderRadius: '8px' }}
                                />
                                </div>
                            </div>
                            </div>
                        </div>
                        {/* OTHER PROJECTS */}
                        <div className="portfolio-grid">
                                <div className="project-card">
                                <h3>Pure Health Nexus <span className="project-year">(2024)</span></h3>
                                <p className="project-stack"><strong>Stack:</strong> React · Firebase · Tailwind CSS</p>
                                <p className="project-role"><strong>Role:</strong> Founder & Lead Dev — built calculators & AI nutrition tools, boosting engagement 30%.</p>
                                                                <div className="project-links">
                                                                    <a href="https://purehealthnexus.com/" className="btn-text" target="_blank" rel="noopener noreferrer">Live Site →</a>
                                                                    {/* <a href="#!" className="btn-text">Case Study →</a>*/}
                                                                </div>
                                </div>
                                <div className="project-card">
                                <h3>Ebenezer Factoreria <span className="project-year">(2024)</span></h3>
                                <p className="project-stack"><strong>Stack:</strong> React · Tailwind CSS</p>
                                <p className="project-role"><strong>Role:</strong> Full-stack developer — created brand site, online ordering, and menu details.</p>
                                                                <div className="project-links">
                                                                    {/* <a href="https://ebenezertamales.com/" className="btn-text" target="_blank" rel="noopener noreferrer">Live Site →</a> */}
                                                                </div>
                                </div>
                            <div className="project-card">
                            <h3>Auction House<span className="project-year"> (2023)</span></h3>
                            <p className="project-stack"><strong>Stack:</strong> Django · Firebase · Tailwind CSS</p>
                            <p className="project-role"><strong>Role:</strong> Developed a Django-based auction platform allowing users to create listings, place bids, manage watchlists, emails, payments, and marketing KPIs.</p>
                                                        <div className="project-links">
                                                            {/* <a href="https://drive.google.com/file/d/1koSNggqoxc5L4s1TQY_ql6YESEpxf1h5/view" className="btn-text" target="_blank" rel="noopener noreferrer">Video Demo →</a> */}
                                                        </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 4. SKILLS */}
                <section id="skills" className="skills">
                    <div className="container">
                        <h2 className="section-title">Technical & Soft Skills</h2>
                        <div className="skills-grid">
                            <div className="skill-category">
                                <h4>Front-End</h4>
                                <div className="skill-tags"><span>HTML5</span><span>CSS3</span><span>JavaScript</span><span>TypeScript</span><span>React</span><span>Tailwind CSS</span><span>BootStrap</span></div>
                            </div>
                            <div className="skill-category">
                                <h4>Back-End</h4>
                                <div className="skill-tags"><span>C#</span><span>.NET Core</span><span>Node.js</span><span>Django</span><span>Python</span> <span>SQL Server</span><span>PostgreSQL</span></div>
                            </div>
                            <div className="skill-category">
                                <h4>Tooling & DevOps</h4>
                                <div className="skill-tags"><span>Git</span><span>Jest</span><span>MSTest</span><span>Firebase</span><span>REST APIs</span><span>Trello</span><span>Figma</span><span>Azure</span>
                                <span>Stripe</span><span>Mailgun</span><span>PiwikPro</span></div>
                            </div>
                            <div className="skill-category">
                                <h4>Soft Skills</h4>
                                <div className="skill-tags"><span>Problem-Solving</span><span>Structured Thinking</span><span>Communication</span><span>Self-Leadership</span><span>Business Awareness</span><span>Technical Understanding</span></div>
                            </div>
                        </div>
                    </div>
                </section>

                        {/* 7. ABOUT ME */}
                        <section id="about" className="about">
                            <div className="container">
                                <h2 className="section-title">Past ⟶ Present ⟶ Future</h2>
                        
                                <div className="about-grid">
                                    <div className="about-card">
                                        <h3>PAST</h3>
                                        <p>For 15+ years I led technical-support, sales, and operations teams at Zankutrol, Dell Inc. and Concentrix, mastering problem-solving, KPI management, and client retention.</p>
                                    </div>
                                    <div className="about-card">
                                        <h3>PRESENT</h3>
                                        <p>IT | System Developer, Software Developer, and founder of Pure Health Nexus, a wellness platform turning data into healthier lives. Developing an AI marketing automation campaign software.</p>
                                    </div>
                                    <div className="about-card">
                                        <h3>FUTURE</h3>
                                        <p>Building scalable wellness and e-commerce apps that tie technology to measurable ROI, powered by a unique blend of engineering skill and account-management insight. Soon launching AI-powered agents that automate busywork for small businesses.</p>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* END ABOUT ME*/}

                {/* 8. SOCIAL PROOF */}
                <section id="reviews" className="reviews">
                    <div className="container">
                        <h2 className="section-title">Reviews & Certificates</h2>
                        <div className="reviews-grid">
                            <blockquote className="review-card">
                            <p>
                                “Corn combined technical expertise with business insight—designing and implementing our automated email flows in Node.js serverless functions.”
                            </p>
                            <footer>— Pavel Schoffer, CEO @ Beaver Codes</footer>
                            </blockquote>
                            <blockquote className="review-card">
                            <p>
                                “His leadership transformed a struggling tech support team into a top-performing unit quarter after quarter.”
                            </p>
                            <footer>— Jose Centeno, Ops Manager @ Concentrix</footer>
                            </blockquote>
                            <blockquote className="review-card">
                            <p>
                                “Demonstrated strategic key account management—building strong client partnerships, driving renewals and upsells for a sustained 25% revenue boost.”
                            </p>
                            <footer>— Cesar Alvarez, CEO @ Zankutrol</footer>
                            </blockquote>
                        </div>
                            {/* === Certificates – Ribbon Style (centered) === */}
                            <div className="certificates certificates--ribbon">
                            <h4>Certificates</h4>

                            <ul className="ribbon-list">
                                <li>Harvard CS50 Web Dev</li>
                                <li>Dell Hardware Certified</li>
                                <li>Sales Coach Certification</li>
                                <li>Convergys Leadership Program</li>
                            </ul>
                            </div>
                    </div>
                </section>
                
                {/* 9. CALL-TO-ACTION */}
                <section id="cta" className="cta">
                <div className="container">
                    <h2 className="cta-title">Let's Build Something Great Together</h2>
                    <p className="cta-subtitle">
                    Need a full-stack developer who also speaks KPI-driven sales and account strategy?  
                    I combine .NET / React expertise with 15 years of business development to deliver tech that
                    <em> moves the bottom line</em>.
                    </p>
                    {/* mailto link opens the user’s email client */}
                    <a
                    href="mailto:cornnahum@hotmail.com?subject=Project%20Inquiry%20from%20Portfolio%20Site"
                    className="btn btn-primary"
                    >
                    Get In Touch
                    </a>
                </div>
                </section>
            </main>

            {/* 10. & 11. CONTACT & FOOTER */}
            <footer id="contact" className="footer">
                <div className="container">
                    <div className="contact-info">
                        <h3>Contact Me</h3>
                        <p>Open to new opportunities and collaborations.</p>
                    </div>
                        <div className="contact-links">
                        <a href="mailto:cornnahum@hotmail.com">cornnahum@hotmail.com</a>
                        <a href="https://linkedin.com/in/cornnahum" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                        <a href="https://github.com/cornnahum" target="_blank" rel="noopener noreferrer">GitHub</a>
                        <span className="contact-item">+46 79 078 09 55</span>
                      {/*  <div className="resume-downloads">
                        <p style={{ display: 'inline', fontWeight: 'bold', marginRight: '0.5rem' }}>Download My CV:</p>
                        <a href="/img/Cornilious CV.pdf" download="Cornilious_CV_ENG.pdf" className="btn-text">(Eng)</a>
                        <a href="/img/Cornilious CV-Swe.pdf" download="Cornilious_CV_SWE.pdf" className="btn-text">  (Swe)</a>
                        </div>*/}
                        </div>
                        
                    <div className="footer-bottom">
                        <a href="#hero" className="back-to-top" onClick={(e) => handleNavClick(e, 'hero')}>↑ Back to Top</a>
                        <p>© 2024 Cornilious Nolasco. All rights reserved.</p>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default Portfolio;